import { render, staticRenderFns } from "./UserProfilePicture.vue?vue&type=template&id=4765fbc4&scoped=true&"
import script from "./UserProfilePicture.vue?vue&type=script&lang=js&"
export * from "./UserProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePicture.vue?vue&type=style&index=0&id=4765fbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765fbc4",
  null
  
)

export default component.exports